import { getRequestListLight } from '../../../api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { toRequestSelectItems } from '../Request.utils'

import { REQUEST_SELECT_DROPDOWN_FLOATING_CONFIG } from './RequestSelect.constants'

import * as styles from './RequestSelect.module.css'

import ServiceRequestIcon from '../../../icons/service-request.svg'

function RequestSelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = REQUEST_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getRequestListLight,
  listProps,
  toPreparedItems = toRequestSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      EntityIcon={ServiceRequestIcon}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      listProps={{
        ...listProps,
        itemProps: {
          ...listProps?.itemProps,
          className: styles.requestSelectListItem,
        },
      }}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default RequestSelect
